import React, { useEffect, useState } from 'react';
import { FaRegCircleXmark } from 'react-icons/fa6';
import { MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { toast } from 'react-toastify';
import { mainurl } from '../../actions/mainurl';
import { useDispatch, useSelector } from 'react-redux';
import { getQueryData } from '../../actions/querieAuction';
import "./Query.css"

function Query() {
  const baseUrl = mainurl;
  const { user } = useSelector((action) => action.authState);
  const { queries } = useSelector((state) => state.querieState);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [deleteData, setDeleteData] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const dispatch = useDispatch();
  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(getQueryData);
  }, [deleteData, dispatch]);

  const handleQuerieDelete = async (id) => {
    if (user?.role !== 'super-admin') {
      return toast.error(`Role ${user?.role} is not allowed to delete`);
    }

    const confirmDelete = window.confirm('Are you sure you want to delete');

    if (!confirmDelete) {
      return;
    }



    try {
      await axios.delete(`${baseUrl}/enquery/delete-enquery/${id}`, {
        withCredentials: true,
      });
      toast.success('Successfully deleted');
      setDeleteData(id);
    } catch (error) {
      console.error('Error deleting query:', error);
    }
  };

  const handleViewDetails = (query) => {
    setSelectedQuery(query);
    setShowDetails(true);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % queries?.length;
    setItemOffset(newOffset);
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = queries?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(queries?.length / itemsPerPage);

  return (
    <div className="query">
      {showDetails && (
        <>
          <div className="showMore_popup_background"></div>
          <div className="showMore_popup">
            <div>
              <FaRegCircleXmark className="query_close_icon" onClick={() => setShowDetails(false)} />
            </div>
            <div className="query_popup_div">
              <div>
                <b>Name :</b> {selectedQuery?.name}
              </div>
              <div>
                <b>Email :</b> {selectedQuery?.email}
              </div>
              <p>
                <b>Message :</b> {selectedQuery?.message}
              </p>
              <p>
                <b>Phone :</b> {selectedQuery?.phone}
              </p>
              <p>
                <b>Country :</b> {selectedQuery?.country}
              </p>
            </div>
          </div>
        </>
      )}
      <h2 className="main_heading">All Queries</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Message</th>
            <th>Details</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentItems &&
            currentItems.map((data) => (
              <React.Fragment key={data._id}>
                <tr>
                  <td className="query_name">{data.name}</td>
                  <td className="query_email">{data.email}</td>
                  <td className="query_email">{data.phone}</td>
                  <td className="query_content">
                    {data?.message?.length > 50 ? `${data.message.substring(0, 30)}... ` : data.message}
                  </td>
                  <td>
                    <button className="querie_more_button" onClick={() => handleViewDetails(data)}>
                      View Details
                    </button>
                  </td>
                  <td>
                    <button className="querie_button" onClick={() => handleQuerieDelete(data._id)}>
                      <MdDelete className="icon" />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
        </tbody>
      </table>
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
    </div>
  );
}

export default Query;
